<div class="relative w-full">
    <p-progress-bar [value]="percentageValue" >
        <ng-template #content let-value></ng-template>
    </p-progress-bar>
    <div class="absolute inset-0 flex items-center justify-center text-sm font-medium text-lrpTicketBlack">
        {{ value}}/{{ max}} {{ label }}
    </div>
</div>